import cn from 'classnames'
import React, { ComponentProps } from 'react'

type MccOtherIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccOtherIcon(props: MccOtherIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('MccOtherIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8 6.5C8.41421 6.5 8.75 6.83579 8.75 7.25C8.75 7.66421 8.41421 8 8 8C7.58579 8 7.25 7.66421 7.25 7.25C7.25 6.83579 7.58579 6.5 8 6.5ZM4 6.5C4.41421 6.5 4.75 6.83579 4.75 7.25C4.75 7.66421 4.41421 8 4 8C3.58579 8 3.25 7.66421 3.25 7.25C3.25 6.83579 3.58579 6.5 4 6.5ZM12 6.5C12.4142 6.5 12.75 6.83579 12.75 7.25C12.75 7.66421 12.4142 8 12 8C11.5858 8 11.25 7.66421 11.25 7.25C11.25 6.83579 11.5858 6.5 12 6.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
